import {
    Login,
    Companies,
    DashBoard,
    //  CreateItemMaster,
    //    ItemMaster,
    ResetPassword,
    UserCompanyMaping,
    SaleOrderEntry,
    CreateModeSetting,
    SaleOrderMaster,
    CreateAccount,
    AccountMaster,
    CreateUser,
    UserMaster,
    UserPartyMapping,
    // CreateAccountMaster,
    // AccountMaster,

} from "../pages/index.js"
import { linksUrl } from "./enum.js"


export const menuPages = [
    {
        path: linksUrl.companies,
        component: <Companies />,
        name: "Companies",
    },

    {
        path: linksUrl.dashboard,
        component: <DashBoard />,
        name: "Dashboard",
    },
    {
        path: linksUrl.salesOrder.createEntry,
        component: <SaleOrderEntry />,
        name: "SaleOrderEntry",
    },

    {
        path: linksUrl.salesOrder.orderMaster,
        component: <SaleOrderMaster />,
        name: "SaleOrderEntry",
    },

    //  {
    //     path: linksUrl.purchaseOrder.createEntry,
    //     component: <SaleOrderEntry />,
    //     name: "PurchaseOrderEntry",
    // },

    // {
    //     path: linksUrl.purchaseOrder.orderMaster,
    //     component: <SaleOrderMaster />,
    //     name: "PurchaseOrderEntry",
    // },
    {
        path: linksUrl.resetPassword,
        component: <ResetPassword />,
        name: "Companies",
    },
    {
        path: linksUrl.modSetting.modSettingMaster,
        component: <CreateModeSetting />,
        name: "ModSettings",
    },
    {
        path: linksUrl.userCompMaping.get,
        component: <UserCompanyMaping />,
        name: "UserCompanyMaping",
    },
    {
        path: linksUrl.userPartyMaping.get,
        component: <UserPartyMapping/>,
        name: "UserPartyMapping",
    },
    {
        path: linksUrl.master.account.createAccountMaster,
        component: <CreateAccount />,
        name: "AccountEntry",
    },
    {
        path: linksUrl.master.account.accountMaster,
        component: <AccountMaster />,
        name: "AccountEntry",
    },
    {
        path: linksUrl.user.createUserEntry,
        component: <CreateUser />,
        name: "OrdAppUserEntry",
    },
     {
        path: linksUrl.user.userMaster,
        component: <UserMaster/>,
        name: "OrdAppUserEntry",
    },
    // {
    //     path: linksUrl.master.item.itemMaster,
    //     component: <ItemMaster />,
    //     name: "ItemMaster",
    // },
    // {
    //     path: linksUrl.master.item.createItemMaster,
    //     component: <CreateItemMaster />,
    //     name: "ItemMaster",
    // },

    // {
    //     path: linksUrl.master.account.createAccountMaster,
    //     component: <CreateAccountMaster />,
    //     name: "AccountMaster",
    // },
    // {
    //     path: linksUrl.master.account.accountMaster,
    //     component: <AccountMaster />,
    //     name: "AccountMaster",
    // },



]